import React from 'react'
import OtpVerification from '../components/OtpVerification'

const LoginPage = () => {
  return (
    <div>
      <OtpVerification/>
    </div>
  )
}

export default LoginPage
